// Feature flag for the v2 Beta state.
//
// During Beta only the Basis tier is bookable. Premium and Exklusiv are
// shown as "Bald verfügbar". When Premium ships, flip BETA_MODE to false
// and extend BETA_AVAILABLE_TIERS accordingly.

export type Tier = "basis" | "premium" | "exklusiv";

export const BETA_MODE = true;
export const BETA_AVAILABLE_TIERS: ReadonlyArray<Tier> = ["basis"];

export function isTierAvailable(tier: Tier): boolean {
  if (!BETA_MODE) return true;
  return BETA_AVAILABLE_TIERS.includes(tier);
}
